import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-segment',
  templateUrl: './segment.component.html',
  styleUrls: ['./segment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SegmentComponent {
  constructor() {}
}
